module.exports = __webpack_public_path__ + "static/instagram_solid-b0e695a1521fe4808eb7b1de83c0a838.png";